/**
 * Pair-repeat take rate. First match is 15%; the same guest+host pair
 * drops to 8% on the second completed trip and 5% from the third.
 *
 * Pure: no I/O. Client and server pass the same policy object from their
 * constants mirrors. Host payout is never derived from this number.
 */

export interface TieredFeeTier {
  minCompletedPairTrips: number
  pct: number
}

export interface TieredFeePolicy {
  version: number
  defaultPct: number
  tiers: readonly TieredFeeTier[]
}

export function resolveGuestServiceFeePct(
  completedPairTrips: number,
  policy: TieredFeePolicy,
): number {
  const trips = Number.isFinite(completedPairTrips)
    ? Math.max(0, Math.floor(completedPairTrips))
    : 0
  const ordered = [...policy.tiers].sort(
    (a, b) => a.minCompletedPairTrips - b.minCompletedPairTrips,
  )
  let pct = policy.defaultPct
  for (const tier of ordered) {
    if (trips >= tier.minCompletedPairTrips) pct = tier.pct
  }
  return pct
}

export function nextGuestServiceFeePct(
  completedPairTrips: number,
  policy: TieredFeePolicy,
): number {
  return resolveGuestServiceFeePct(completedPairTrips + 1, policy)
}

export function pairFeeOrdinal(completedPairTrips: number): 1 | 2 | 3 {
  const trips = Number.isFinite(completedPairTrips)
    ? Math.max(0, Math.floor(completedPairTrips))
    : 0
  if (trips <= 0) return 1
  if (trips === 1) return 2
  return 3
}
